// Determine the base URL based on environment
const getBaseUrl = () => {
  // Check if we have a direct VITE_BASE_SERVER_URL in env

  if (!import.meta.env.VITE_BASE_SERVER_URL) {
    throw new Error("VITE_BASE_SERVER_URL is not set");
  }

  return import.meta.env.VITE_BASE_SERVER_URL.replace(/\/$/, ""); // Remove trailing slash

  // // Fallback to NODE_ENV check
  // const nodeEnv = import.meta.env.NODE_ENV || import.meta.env.VITE_NODE_ENV;

  // if (nodeEnv === "production") {
  //   return "https://gearlab.digital";
  // } else {
  //   return "https://dev.gearlab.digital";
  // }
};

export const BASE_URL = getBaseUrl();

// Update PRODUCTS_PAGE_URL to use the dynamic BASE_URL
export const PRODUCTS_PAGE_URL = `${BASE_URL}/api/glabp/?page=Product_All`;

// Development/debugging URLs (commented out)
// export const BASE_URL = 'http://192.168.18.140:8000';
// export const BASE_URL = "http://127.0.0.1:8000";
// export const BASE_URL = "http://34.155.20.73";
// export const BASE_URL = "https://dev.gearlab.digital";
// export const BASE_URL = 'https://h6nqqrsr-8000.inc1.devtunnels.ms'
